import { useState } from 'react'

import { Link } from '@tanstack/react-router'

import { Button } from '@/components/ui/button'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

export default function SectionInformation() {
  const TAB_MENU = [
    {
      key: 'HAVE_APPLY',
      value: 'SUDAH COBA APPLY?',
    },
    {
      key: 'CANT_JAPAN_LANGUANGE',
      value: 'BELUM BISA BAHASA JEPANG?',
    },
  ]

  const [active, setActive] = useState<string>('CANT_JAPAN_LANGUANGE')

  return (
    <div className="pt-14">
      <div className="pointer-events-none absolute right-0 -z-30 hidden md:flex">
        <img src="/img/landing/bg-map-japan1.svg" />
      </div>
      <div className="z-50 flex items-center justify-center px-6 md:px-0">
        <Tabs
          value={active}
          onValueChange={(val) => setActive(val)}
          className="w-full space-y-6"
        >
          <div className="flex justify-center">
            <div className="overflow-auto rounded-xl border-2 border-primary-yes bg-white shadow-sm">
              {/* <TabsList className="flex h-auto min-w-fit gap-4 bg-transparent p-2 md:flex-nowrap [&>*]:flex-1">
                {TAB_MENU.map((menu) => (
                  <TabsTrigger
                    key={menu.key}
                    value={menu.key}
                    className="text-wrap rounded-md px-12 py-2 text-xs text-[#9E9E9E] transition-colors duration-300 data-[state=active]:bg-primary-yes data-[state=active]:text-white md:text-nowrap md:text-sm"
                  >
                    {menu.value}
                  </TabsTrigger>
                ))}
              </TabsList> */}
            </div>
          </div>
          <div className="md:px-36">
            {[
              ['HAVE_APPLY', <TabHaveApply />],
              ['CANT_JAPAN_LANGUANGE', <TabCantJapan />],
            ].map(([key, content]: any) => {
              return (
                <TabsContent
                  value={key}
                  key={key}
                  className="focus-visible:ring-0"
                >
                  {content}
                </TabsContent>
              )
            })}
          </div>
        </Tabs>
      </div>
      {/* <div className="mt-8 md:px-36">
        <div className="flex flex-col justify-center gap-6 bg-[#FAF3FA] px-16 py-8">
          <div className="text-center text-2xl font-semibold">
            Mau bikin CV sesuai dengan <br />
            standar perusahaan Jepang?{' '}
            <span className="text-primary-yes">GRATIS!</span>
          </div>
          <div>
            <img src="/img/landing/flow-registration.svg" />
          </div>
        </div>
      </div> */}
    </div>
  )
}

function TabHaveApply() {
  return (
    <div className="z-50 flex w-full rounded-md bg-[#F3F7FA] p-4 pt-6 md:pt-14">
      <div className="hidden md:flex md:w-1/3">
        <img className="-mt-28 w-72" src="/img/landing/people-1.svg" />
      </div>
      <div className="flex w-full flex-col justify-center gap-4 md:w-auto">
        <div className="text-2xl font-semibold">
          Sudah coba Apply CV tapi belum dapat panggilan
          <br /> interview juga?
        </div>
        <div className="text-sm font-light text-[#475467]">
          Temukan tips, trik, dan solusi efektif untuk meningkatkan peluangmu{' '}
          <br /> mendapatkan panggilan interview. Jangan biarkan CV-mu hanya
          berhenti di meja perekrut!
        </div>
        <div className="flex">
          {/* <Button variant={'primary'}>Pelajari Lebih Lanjut</Button> */}
        </div>
      </div>
    </div>
  )
}

function TabCantJapan() {
  return (
    <div className="relative z-50 flex flex-col rounded-md bg-[#FAF3F3] lg:flex-row lg:flex-wrap">
      <div className="pointer-events-none bottom-0 mx-auto aspect-square w-1/2 shrink-0 lg:mx-0 lg:w-auto">
        <img className="w-full select-none" src="/img/landing/people-2.svg" />
      </div>

      <div className="flex flex-1 flex-col justify-center gap-4 p-8">
        <div className="text-2xl font-semibold">
          Ingin memulai karir di Jepang tapi masih terkendala di bahasa?
        </div>
        <div className="font-light text-[#475467]">
          Ikuti program pelatihan bahasa Jepang dari dasar hingga lancar dengan
          metode yang mudah dipahami. Kami siap bantu kamu untuk wujudkan karir
          impian di Jepang!
        </div>
        <div>Jadi yang pertama tahu kapan kelasnya dibuka!</div>
        <div className="flex">
          <Button variant={'primary'} asChild>
            <a href="https://n5prep.yes.co.id/" target="_blank">
              Join Waiting List Sekarang
            </a>
          </Button>
        </div>
      </div>
    </div>
  )
}

// function TabCantJapan() {
//   return (
//     <div className="z-50 flex w-full rounded-md bg-[#FAF3F3] p-4 pt-6 md:pt-14">
//       <div className="hidden md:flex md:w-1/2 md:items-center md:justify-center">
//         <img className="-mt-28 w-72" src="/img/landing/people-2.svg" />
//       </div>
//       <div className="flex w-full flex-col justify-center gap-4 md:w-auto">
//         <div className="text-2xl font-semibold">
//           Ingin memulai karir di Jepang tapi masih
//           <br />
//           terkendala di bahasa?
//         </div>
//         <div className="w-2/3 font-light text-[#475467]">
//           Ikuti program pelatihan bahasa Jepang dari dasar hingga lancar dengan
//           metode yang mudah dipahami. Kami siap bantu kamu untuk wujudkan karir
//           impian di Jepang!
//         </div>
//         <div>Jadi yang pertama tahu kapan kelasnya dibuka!</div>
//         <div className="flex">
//           <a href="https://bit.ly/bahasajepangwaitinglist">
//             <Button variant={'primary'}>Join Waiting List Sekarang</Button>
//           </a>
//         </div>
//       </div>
//     </div>
//   )
// }
